import React from 'react';
interface MorphingBlobProps {
  color?: string;
  size?: number;
  className?: string;
  delay?: number;
}
const MorphingBlob: React.FC<MorphingBlobProps> = ({
  color = '#3d87e8',
  size = 300,
  className = '',
  delay = 0
}) => {
  return <div className={`absolute animate-blob ${className}`} style={{
    width: `${size}px`,
    height: `${size}px`,
    background: `linear-gradient(135deg, ${color}40, ${color}20)`,
    filter: 'blur(40px)',
    animationDelay: `${delay}s`
  }} data-id="element-173" />;
};
export default MorphingBlob;